import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { IResetPassword } from 'src/app/core/interfaces/login/resetpassword.interface';
import { LoginService } from 'src/app/core/services/login/login.service';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';
import { reloadApp } from 'src/app/core/ui-helpers/functions/redirect/reload-app';
import { environment } from 'src/environments/environment';

// Macth password function
function passwordMatchValidator(formGroup: FormGroup) {
  const password = formGroup.get('password');
  const confirmpassword = formGroup.get('confirmpassword');

  if (password?.value !== confirmpassword?.value) {
    confirmpassword?.setErrors({ passwordMismatch: true });
  } else {
    confirmpassword?.setErrors(null);
  }
}

function passwordStrengthValidator(
  control: AbstractControl,
): { [key: string]: any } | null {
  const password = control.value;

  // Regex to match the password requirements :A password must be at least 9 characters and contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character.
  const passwordRegex =
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+=[\]{};':"\\|,.<>/?]).{9,}$/;

  // Test the password against the regex
  const isValid = passwordRegex.test(password);

  // If the password is invalid, return the passwordStrength error
  return isValid ? null : { passwordStrength: true };
}

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss'],
})
export class ResetpasswordComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  headerText = 'Reset Password';
  passwordText = 'Password';
  confirmpasswordText = 'Confirm Password';
  resetPasswordBtnText = 'Reset';
  backText = 'Login';
  backUrl = 'OnBoarding/Login/Login';
  emailValFromHidden = '';
  tokenValFromHidden = '';
  userIdValFromHidden = '';
  subheaderText =
    'A password must be at least 9 characters and contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character.';
  form: FormGroup;
  subscriptions: Subscription[] = [];

  private apiUrl = environment.apiUrl;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private fb: FormBuilder,
    private lgs: LoginService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        password: ['', [Validators.required, passwordStrengthValidator]],
        confirmpassword: ['', Validators.required],
      },
      { validator: passwordMatchValidator },
    );
  }

  ngAfterViewInit() {
    // Fetch data from mvc view set required data
    const userId = document.getElementsByName('UserId')[0] as HTMLInputElement;
    const email = document.getElementsByName('Email')[0] as HTMLInputElement;
    const token = document.getElementsByName('Token')[0] as HTMLInputElement;
    this.emailValFromHidden = email.value;
    this.userIdValFromHidden = userId.value;
    this.tokenValFromHidden = token.value;
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  async submitResetPasswordForm() {
    if (this.form.valid) {
      const payload: IResetPassword = {
        UserId: this.userIdValFromHidden,
        Token: this.tokenValFromHidden,
        Email: this.emailValFromHidden,
        Password: this.form.get('password')?.value ?? '',
        ConfirmPassword: this.form.get('confirmpassword')?.value ?? '',
      };
      await this.subscriptions.push(
        this.lgs.resetPassword(payload).subscribe((res: any) => {
          // redirect to login if success
          reloadApp(environment);
        }),
      );
      return true;
    } else {
      this.form.markAllAsTouched(); // mark all controls as touched to trigger validation
    }
    return false;
  }
}
